import React, { useEffect, useState } from "react";
import paths from "../../../routes/paths";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/lemon/371776777_242200888790517_936034044549931900_n.jpg";
const Header = () => {
  return (
    <>
      <nav className="flex justify-center items-center absolute z-20 top-0 min-w-full py-4 bg-[#F3DFAB] ">
        <img src={logo} className="w-20 rounded-full" alt="" />
      </nav>
    </>
  );
};

export default Header;
